import React from 'react'
import PropTypes from 'prop-types'
import WhyPricelineJustification from './WhyPricelineJustification'
import { BlockLink, Box, Container, Flex } from 'pcln-design-system'
import contents from './why-priceline-content'

const WhyPriceline = props => {
  const data = props.contents || contents
  return (
    <Box color='background.light' p={3}>
      <Container>
        <Flex justifyContent='space-around'>
          {data.map(({ href, ...props }) => {
            if (href) {
              return (
                <Box width={1 / 4} p={2}>
                  <BlockLink href={href}>
                    <WhyPricelineJustification {...props} />
                  </BlockLink>
                </Box>
              )
            }
            return (
              <Box width={[1, 1 / 4]} p={2}>
                <WhyPricelineJustification {...props} />
              </Box>
            )
          })}
        </Flex>
      </Container>
    </Box>
  )
}
WhyPriceline.propTypes = {
  contents: PropTypes.arrayOf(PropTypes.object)
}

export default WhyPriceline
